import type { Entry } from 'contentful';
import type H from 'history';
import React from 'react';
import { Route, Switch, withRouter, RouteComponentProps, match } from 'react-router';

import { ModalType, ModalAssembly } from 'api/contentful/contentTypes.cloverdotcom';
import { Modal } from 'components/Modal/Modal';
import { componentKey, getField, getSys } from 'utils/EntryUtil';

import { isRootModalUrl } from 'utils/ModalRoute';
import { withDynamicModal } from '../DynamicModal/WithDynamicModal';
import { ModalModuleContentWrapper } from '../Modal/ModalContentWrapper';

interface INestedModals extends RouteComponentProps {
  entries: ReadonlyArray<Entry<ModalAssembly>>;
  clearEntries: () => void;
}

export function onRequestClose(history: H.History, match: match, modalBaseUrl?: string) {
  if (modalBaseUrl) {
    history.push(modalBaseUrl);
    return;
  }

  if (!window.history.state) {
    // push, so back button works
    history.push(isRootModalUrl(match.url) ? '/' : match.url);
    return;
  }

  // close by using browser back
  history.goBack();
}

class NestedModals extends React.PureComponent<INestedModals> {
  readonly onRequestClose = () => onRequestClose(this.props.history, this.props.match);

  componentWillUnmount() {
    this.props.clearEntries();
  }

  render() {
    const { match, entries } = this.props;
    const modalBaseUrl = match.url.split('/m/')[0];

    return (
      <Switch>
        {entries.map((entry, index) => {
          const contentType = getField(entry, 'type' as any);

          return (
            <Route
              key={componentKey(entry, index)}
              path={`${modalBaseUrl === '/' || isRootModalUrl(modalBaseUrl) ? '' : modalBaseUrl}/m/${
                getField(entry, 'slug') || getSys(entry, 'id')
              }`}
              render={() => (
                <Modal
                  key={entry.sys.id}
                  isOpen
                  onRequestClose={this.onRequestClose}
                  mediaOnly={contentType === ModalType.MediaOnly}
                  isForm={contentType === ModalType.PartnerContactForm}
                  isSheet={contentType === ModalType.Sheet}
                  isLightbox={contentType === ModalType.Lightbox}
                >
                  <ModalModuleContentWrapper entry={entry} modalBaseUrl={modalBaseUrl} />
                </Modal>
              )}
            />
          );
        })}
      </Switch>
    );
  }
}

const Routed = withRouter(NestedModals);
type Routed = typeof Routed;

const DynamicModaled = withDynamicModal(({ modals, clear }) => ({
  entries: modals as ReadonlyArray<Entry<ModalAssembly>>,
  clearEntries: clear,
}))(Routed);

export { DynamicModaled as NestedModals, Routed as _NestedModals };
